import React from "react";
import memoize from "memoize-one";

import { connect } from 'react-redux';
import * as orderActions from '../../redux/actions/orderAction'
import {bindActionCreators} from "redux";

class Popup extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            storeClerkToken: window.sessionStorage.getItem('storeClerkToken'),
            loader : false,
            returnItems: [], //this.props.requestRMA.returnItems.filter(e => !e.isExchange)
            exchangeItems: [] //this.props.requestRMA.returnItems.filter(e => e.isExchange)
        }
        this.createRMA = this.createRMA.bind(this);
    }

    filterReturnItems = memoize(
        (list) => list.filter(it => !it.isExchange)
    )

    filterExchangeItems = memoize(
        (list) => list.filter(it => it.isExchange)
    )

    async  createRMA() {
        
        this.setState({ loader: true });  
        let requestRMA = { "requestRMAData": this.props.requestRMA };         
        await this.props.createRMARequest(requestRMA, this.props);
        this.props.handleClose();
        this.setState({ loader: false });  
    }

    render() {
        const { loader } = this.state;
        const exchangeItems = this.props.requestRMA.returnItems ? this.filterExchangeItems(this.props.requestRMA.returnItems) : []
        const returnItems = this.props.requestRMA.returnItems ? this.filterReturnItems(this.props.requestRMA.returnItems) : []
        return (
            <div className="modal-dialog modal-lg">
                <div className="modal-content">
                    <div className="modal-header">
                        <button type="button" className="close" data-dismiss="modal">&times;</button>
                    </div>
                    <div className="modal-body">
                        <div id="exchange-items">
                            {this.props.requestRMA.returnPolicy && this.props.requestRMA.isExchange &&
                                <React.Fragment>
                                    <div className="sub-title">EXCHANGE ITEMS</div>
                                    <div className="model-paragraph"
                                         dangerouslySetInnerHTML={{__html: this.props.requestRMA.returnPolicy.exchangeInstructions}}/>

                                    <table className="table table-borderless no-margin-bottom">
                                        <tbody>
                                        {exchangeItems.map((items, index) => (
                                            <tr key={index}>
                                                <td className="w-40">
                                                    {items.imageUrl &&
                                                    <div>
                                                        <span className="item-img">
                                                            <img alt="product"  src={items.imageUrl} className="popup-product-img"/>
                                                        </span>
                                                    </div>
                                                    }
                                                </td>
                                                <td>
                                                    <ul className="reason-notest">
                                                        <li className="p-name">{items.itemName}</li>
                                                        {items.color &&
                                                        <li className="p-name">Color : {items.color}</li>
                                                        }
                                                        {items.size &&
                                                        <li className="p-name">Size : {items.size}</li>
                                                        }
                                                        {(this.state.storeClerkToken && items.sku) &&
                                                        <li className="p-name">SKU: {items.sku}</li>
                                                        }
                                                        <li className="reason">Reason: {items.returnReason}</li>
                                                        {items.returnResponse !== 'SelectResponse' &&
                                                        <li className="reason">Return response: {items.returnResponse}</li>
                                                        }
                                                        {items.returnNotes &&
                                                        <li className="reason">Notes: {items.returnNotes} </li>
                                                        }

                                                        {this.state.storeClerkToken &&
                                                            <li className="p-name" ><input type="checkbox" name="name" checked={items.returnedInStore} value="" /> Returned In Store</li>
                                                        }
                                                    </ul>

                                                </td>
                                                <td className="float-right">qty : {items.returnQuantity}</td>
                                            </tr>
                                        ))}
                                        </tbody>
                                    </table>
                                    {this.state.storeClerkToken &&
                                    <p className="paragraphs">${this.props.requestRMA.returnOrderHeader.totalEstimatedRefund} will be credited back to the customer in 5 – 7 business days.</p>
                                    }
                                </React.Fragment>
                            }
                        </div>
                        <div id="replacement-items">
                            {this.props.requestRMA.isExchange &&
                                <React.Fragment>
                                    <div className="sub-title">REPLACEMENT ITEMS</div>
                                    <table className="table table-borderless no-margin-bottom">
                                        <tbody>
                                        {exchangeItems.map((items, index) => (
                                            <tr key={index}>
                                                <td>
                                                    <ul className="reason-notest">
                                                        <li className="p-name">{items.exchangeItem.productName}</li>
                                                    </ul>
                                                </td>
                                                <td className="float-right">qty : {items.returnQuantity}</td>
                                            </tr>
                                        ))}
                                        </tbody>
                                    </table>
                                </React.Fragment>
                            }
                        </div>
                        {returnItems && returnItems.length > 0 &&
                        <div id="return-items">
                            {(this.props.requestRMA.returnPolicy && !this.state.storeClerkToken) ?
                                <React.Fragment>
                                    <div className="sub-title">RETURN ITEMS</div>
                                    <div className="model-paragraph"
                                         dangerouslySetInnerHTML={{__html: this.props.requestRMA.returnPolicy.returnInstructions}}/>
                                </React.Fragment>
                                :
                                <React.Fragment>
                                    <div className="p-sub-title">Attention.</div>
                                    <br></br>
                                    <p className="paragraphs"> These items have been modified. Please confirm the
                                        changes before submitting.</p>
                                </React.Fragment>
                            }

                            <table className="table table-borderless no-margin-bottom">
                                <tbody>
                                {returnItems.map((items, index) => (
                                    <tr key={index}>
                                        <td className="w-40">
                                            {items.imageUrl &&
                                            <div>
                                                <span className="item-img">
                                                    <img alt="product" src={items.imageUrl}
                                                         className="popup-product-img"/>
                                                </span>
                                            </div>
                                            }
                                        </td>
                                        <td>
                                            <ul className="reason-notest">
                                                <li className="p-name">{items.itemName}</li>
                                                {items.color &&
                                                <li className="p-name">Color : {items.color}</li>
                                                }
                                                {items.size &&
                                                <li className="p-name">Size : {items.size}</li>
                                                }
                                                {(this.state.storeClerkToken && items.sku) &&
                                                <li className="p-name">SKU: {items.sku}</li>
                                                }
                                                <li className="reason">Reason: {items.returnReason}</li>

                                                {items.returnNotes &&
                                                <li className="reason">Notes: {items.returnNotes} </li>
                                                }

                                                {this.state.storeClerkToken &&
                                                <li className="p-name"><input disabled type="checkbox" name="name"
                                                                              checked={items.returnedInStore}
                                                                              value=""/> Returned In Store</li>
                                                }
                                            </ul>

                                        </td>
                                        <td className="float-right">qty : {items.returnQuantity}</td>
                                    </tr>
                                ))}
                                </tbody>
                            </table>
                            {this.state.storeClerkToken &&
                            <p className="paragraphs">${this.props.requestRMA.returnOrderHeader.totalEstimatedRefund} will
                                be credited back to the customer in 5 – 7 business days.</p>
                            }
                        </div>
                        }


                    {(this.props.requestRMA && this.props.requestRMA.returnOrderHeader && !this.state.storeClerkToken) &&
                        <div className="float-right">
                                <table className="table table-borderless td-pad-5" width="300px">
                                    <tbody>
                                        <tr>
                                            <td align="right">Refund Subtotal</td>
                                            <td className="float-right">${this.props.requestRMA.returnOrderHeader.refundSubtotal.toFixed(2)}</td>
                                        </tr>
                                        {!(this.props.requestRMA.returnPolicy.showReturnShipping === 'N' && this.props.requestRMA.returnOrderHeader.refundShipping === 0) && !this.props.requestRMA.isExchange &&
                                        <tr>
                                            <td align="right">Return Shipping</td>
                                            <td className="float-right">
                                                <i>{this.props.requestRMA.returnOrderHeader.refundShipping===0?'free':'$'+this.props.requestRMA.returnOrderHeader.refundShipping.toFixed(2)}</i>
                                            </td>
                                        </tr>}
                                        {!!this.props.requestRMA.returnOrderHeader.refundedAmount &&
                                        <tr>
                                            <td align="right">-Refund</td>
                                            <td className="float-right">
                                                ${(this.props.requestRMA.returnOrderHeader.refundedAmount).toFixed(2)}
                                            </td>
                                        </tr>
                                        }
                                        {!(this.props.requestRMA.returnPolicy.showExchangeShipping === 'N' && this.props.requestRMA.returnOrderHeader.exchangeShipping === 0) && this.props.requestRMA.isExchange &&
                                        <tr>
                                            <td align="right">Exchange Shipping</td>
                                            <td className="float-right">
                                                <i>{this.props.requestRMA.returnOrderHeader.exchangeShipping===0?'free':'$'+this.props.requestRMA.returnOrderHeader.exchangeShipping.toFixed(2)}</i>
                                            </td>
                                        </tr>}
                                        {this.props.requestRMA.isExchange &&
                                        <tr>
                                            <td align="right">Exchange</td>
                                            <td className="float-right">
                                                <i>${(this.props.requestRMA.returnOrderHeader.exchangeTotal || 0.0).toFixed(2)}</i>
                                            </td>
                                        </tr>
                                        }
                                        <tr>
                                            <td align="right"><strong>Total Estimated Refund</strong></td>
                                            <td className="float-right"><strong>${this.props.requestRMA.returnOrderHeader.totalEstimatedRefund}</strong></td>
                                        </tr>
                                    </tbody>
                                </table>
                        </div>
                    }
                        {this.state.storeClerkToken ?
                        <div className="float-right">
                            <table className="table table-borderless" width="300px">
                                <tbody>
                                    <tr align="center">
                                        <td> <button  data-dismiss="modal" type="button" className="btn btn-primary link-btn">CANCEL RETURN  </button></td>
                                        <td> <button data-dismiss="modal" type="button" onClick={this.createRMA} className="btn btn-primary btn-new">SUBMIT RETURN </button></td>
                                    </tr>

                                </tbody>
                            </table>
                        </div>
                        :
                        <div className="text-center btn-sections">
                            <button 
                                type="button" 
                                onClick={this.createRMA} 
                                className="btn btn-primary btn-new"
                                disabled={loader}
                            >
                                Submit & Download Return Slip
                            </button>
                            <div>
                                <br></br>
                                <a href="" data-dismiss="modal" className="backlink">{this.state.loader} CANCEL RETURN</a>
                            </div>
                        </div>
                        }
                    </div>
                </div>
                {this.state.loader &&
                    <div className="loading">Loading&#8230;</div>
                }
            </div>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return {
        createRMARequest: bindActionCreators(orderActions.createRMARequest, dispatch)
    }
}

export default connect(null, mapDispatchToProps)(Popup);





// WEBPACK FOOTER //
// ./src/components/OrderDetails/ReturnPopUp.js